import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Breadcrumbs from './breadcrumbs.js';

const BreadcrumbsContainer = withRouter(connect(
  (state) => ({
  }),
  (dispatch) => ({
  })
)(Breadcrumbs));

export default BreadcrumbsContainer;

